import { ChevronRight } from "lucide-react";
import { Fragment } from "react";
import { Button as RACButton } from "react-aria-components";

// Earlier steps are links back; later ones stay locked until the current step is complete.
export function WizardProgress({
  onGoToStep,
  step,
  steps,
}: {
  onGoToStep: (step: number) => void;
  step: number;
  steps: string[];
}) {
  return (
    <nav
      aria-label="Progress"
      className="border-b border-border-secondary px-xl py-lg"
    >
      <ol className="flex flex-wrap items-center gap-sm text-sm font-medium">
        {steps.map((label, index) => {
          const stepNumber = index + 1;

          return (
            <Fragment key={label}>
              {index > 0 && (
                <li aria-hidden>
                  <ChevronRight className="size-5 text-fg-quaternary" />
                </li>
              )}
              <li aria-current={step === stepNumber ? "step" : undefined}>
                {stepNumber < step ? (
                  <RACButton
                    className="cursor-pointer rounded-sm px-md py-xs text-text-tertiary outline-hidden hover:bg-bg-secondary hover:text-text-secondary focus-visible:ring-2 focus-visible:ring-border-brand"
                    onPress={() => onGoToStep(stepNumber)}
                  >
                    {stepNumber} {label}
                  </RACButton>
                ) : (
                  <span
                    className={
                      step === stepNumber
                        ? "block rounded-sm bg-bg-brand-primary px-md py-xs text-text-brand-secondary"
                        : "block px-md py-xs text-text-quaternary"
                    }
                  >
                    {stepNumber} {label}
                  </span>
                )}
              </li>
            </Fragment>
          );
        })}
      </ol>
    </nav>
  );
}
